import { defineMessages } from "react-intl";

export const PREP_INSTRUCTIONS_PAGE_LABELS = defineMessages({
  title: {
    id: "prep.prepInstructionsPage.title",
    defaultMessage: "Select Prep Instructions",
  },
  description: {
    id: "prep.prepInstructionsPage.description",
    defaultMessage: "Choose the relevant prep instructions to ensure your products are packaged and handled correctly.",
  },
  submitError: {
    id: "prep.prepInstructionsPage.error",
    defaultMessage: "An error occurred. Please try again.",
  },
  labels: {
    coverLabels: {
      id: "prep.prepInstructionsPage.labels.coverLabels",
      defaultMessage: "Cover Existing Labels (Yes/No)",
    },
    selectLabelPlacement: {
      id: "prep.prepInstructionsPage.labels.selectLabelPlacement",
      defaultMessage: "Select label placement",
    },
  },
});
